import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../buildStore';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import { getIsUngatedForSpotlightWelcomeMessage } from '../../widget-data/selectors/widgetDataSelectors';
import { showWelcomeMessagePopup } from '../../spotlight/welcome-message/reducers/spotlightWelcomeMessagePopupSlice';
const WELCOME_MESSAGE_POPUP_DELAY_MS = 30000;
// Arms a 30s timer that reveals the hardcoded, portal-53-only welcome
// message popup for first-time visitors. Re-arms from scratch on any
// transient dip in eligibility rather than latching permanently, so a
// brief blip (e.g. thread data still settling) can't disable it for the
// rest of the session. See spotlightWelcomeMessagePopupSlice for how
// opening the widget before the timer fires permanently suppresses the
// popup afterwards.
export const useShowWelcomeMessagePopup = ({
  areThreadsLoaded,
  hasExistingThread,
  hasAnyPersistedThreads
}) => {
  const dispatch = useAppDispatch();
  const isUngated = useAppSelector(getIsUngatedForSpotlightWelcomeMessage);

  // Without areThreadsLoaded, this could be "eligible" from the very first
  // render (hasExistingThread/hasAnyPersistedThreads default to false before
  // thread history resolves), arming the timer before we actually know
  // whether this is a first-time visitor.
  const isEligible = isUngated && getIsPortal53() && areThreadsLoaded && !hasExistingThread && !hasAnyPersistedThreads;
  useEffect(() => {
    if (!isEligible) return undefined;
    const timeoutId = setTimeout(() => {
      dispatch(showWelcomeMessagePopup());
    }, WELCOME_MESSAGE_POPUP_DELAY_MS);
    return () => clearTimeout(timeoutId);
  }, [dispatch, isEligible]);
};